/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { GetNotes200ResponseNotesInner } from './GetNotes200ResponseNotesInner';
import {
    GetNotes200ResponseNotesInnerFromJSON,
    GetNotes200ResponseNotesInnerFromJSONTyped,
    GetNotes200ResponseNotesInnerToJSON,
    instanceOfGetNotes200ResponseNotesInner,
} from './GetNotes200ResponseNotesInner';

/**
 * 
 * @export
 * @interface GetNotes200Response
 */
export interface GetNotes200Response {
    /**
     * 
     * @type {Array<GetNotes200ResponseNotesInner>}
     * @memberof GetNotes200Response
     */
    notes: Array<GetNotes200ResponseNotesInner>;
}


/**
 * Check if a given object implements the GetNotes200Response interface.
 */
export function instanceOfGetNotes200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "notes" in value;
    return isInstance;
}

export function GetNotes200ResponseFromJSON(json: any): GetNotes200Response {
    return GetNotes200ResponseFromJSONTyped(json, false);
}

export function GetNotes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNotes200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'notes': ((json['notes'] as Array<any>).map(GetNotes200ResponseNotesInnerFromJSON)),
    };
}

export function GetNotes200ResponseToJSON(value?: GetNotes200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'notes': ((value.notes as Array<any>).map(GetNotes200ResponseNotesInnerToJSON)),
    };
}

